import { render, staticRenderFns } from "./StoreContactInfo.vue?vue&type=template&id=62bb0871&scoped=true&"
import script from "./StoreContactInfo.vue?vue&type=script&lang=ts&"
export * from "./StoreContactInfo.vue?vue&type=script&lang=ts&"
import style0 from "./StoreContactInfo.vue?vue&type=style&index=0&id=62bb0871&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bb0871",
  null
  
)

export default component.exports